import firebase from "firebase";
import { OlabAccess } from "./olabaccess.js";
import { OlabUtils } from "./olabutils.js";

class OlabUser {
  constructor(item) {
    if (item == null) {
      this.initUser();
    } else {
      this.auth_uid = item.auth_uid ? item.auth_uid : null;
      this.display_name = item.display_name ? item.display_name : null;
      this.email = item.email ? item.email : null;
      // "active", "pending", "suspended"
      this.status = item.status ? item.status : "active";
      this.selected = item.selected
        ? item.selected
        : {
            cart_id: "",
            construct_id: "",
            package_id: "",
            project_id: ""
          };
      this.olab_access = item.olab_access ? item.olab_access : new OlabAccess();
      this.created_date = item.created_date ? item.created_date : null;
      this.updated_date = item.updated_date ? item.updated_date : null;
    }
  }

  static getCreateOlabUserConverter() {
    // Firestore data converter
    let olabUserConverter = {
      toFirestore: function(item) {
        return {
          auth_uid: item.auth_uid,
          display_name: item.display_name,
          email: item.email,
          status: item.status,
          selected: item.selected,
          olab_access: {
            visible: item.olab_access.visible,
            allow: item.olab_access.allow,
            roles: item.olab_access.roles,
            groups: item.olab_access.groups
          },
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabUser(data);
      }
    };
    return olabUserConverter;
  }

  static getUpdateOlabUserConverter() {
    // Firestore data converter
    let olabUserConverter = {
      toFirestore: function(item) {
        return {
          auth_uid: item.auth_uid,
          display_name: item.display_name,
          email: item.email,
          status: item.status,
          selected: item.selected,
          olab_access: {
            visible: item.olab_access.visible,
            allow: item.olab_access.allow,
            roles: item.olab_access.roles,
            groups: item.olab_access.groups
          },
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabUser(data);
      }
    };
    return olabUserConverter;
  }

  initUser() {
    OlabUtils.infoLog("OlabUser.initUser() ...");
    this.auth_uid = null;
    this.display_name = null;
    this.email = null;
    this.status = "active";
    this.selected = {
      cart_id: "",
      construct_id: "",
      package_id: "",
      project_id: ""
    };
    this.olab_access = new OlabAccess();
    this.created_date = null;
    this.updated_date = null;
  }

  set(item) {
    OlabUtils.infoLog("OlabUser.set() ...");
    this.auth_uid = item.auth_uid;
    this.display_name = item.display_name;
    this.email = item.email;
    this.status = item.status;
    this.selected = item.selected;
    this.olab_access = item.olab_access;
    this.created_date = item.created_date;
    this.updated_date = item.updated_date;
  }

  static infoLog(item) {
    OlabUtils.infoLog("OlabUser.infoLong() ... printing ...");
    OlabUtils.infoLog("item.auth_uid = " + item.auth_uid);
    OlabUtils.infoLog("item.display_name = " + item.display_name);
    OlabUtils.infoLog("item.email = " + item.email);
    OlabUtils.infoLog("item.status = " + item.status);
    OlabUtils.infoLog("item.selected.cart_id = " + item.selected.cart_id);
    OlabUtils.infoLog(
      "item.selected.construct_id = " + item.selected.construct_id
    );
    OlabUtils.infoLog("item.selected.package_id = " + item.selected.package_id);
    OlabUtils.infoLog("item.selected.project_id = " + item.selected.project_id);
    OlabUtils.infoLog("item.olab_access.visible = " + item.olab_access.visible);
    OlabUtils.infoLog("item.olab_access.allow = " + item.olab_access.allow);
    OlabUtils.infoLog("item.olab_access.roles = " + item.olab_access.roles);
    for (const key in item.olab_access.roles) {
      // check if the property/key is defined in the object itself, not in parent
      if (Object.prototype.hasOwnProperty.call(item.olab_access.roles, key)) {
        OlabUtils.infoLog(
          "roles: " + key + " = " + item.olab_access.roles[key]
        );
      }
    }
    OlabUtils.infoLog("item.olab_access.groups = " + item.olab_access.groups);
    for (const key in item.olab_access.groups) {
      // check if the property/key is defined in the object itself, not in parent
      if (Object.prototype.hasOwnProperty.call(item.olab_access.groups, key)) {
        OlabUtils.infoLog(
          "groups: " + key + " = " + item.olab_access.groups[key]
        );
      }
    }
    OlabUtils.infoLog("item.created_date = " + item.created_date);
    OlabUtils.infoLog("item.updated_date = " + item.updated_date);
  }
}

export { OlabUser };
